import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DocumentModel} from "../../../common/api/model/document.model";
import {DocumentConverter} from "../../../common/api/converter/document.converter";
import {DocumentRepository} from "../../../common/impl/service/ngrx/document.repository";
import {AbstractActionService} from "../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {DocumentSignPayload} from "../../../common/api/service/documentSignAction.service";
import {DocumentTemplateGenerateDocumentPayload} from "./documentTemplateGenerateDocument.service";

@Injectable()
export class DocumentTemplateSignService
    extends AbstractActionService<DocumentTemplateSignPayload, DocumentModel> {

    constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                httpClient: HttpClient,
                private converter: DocumentConverter,
                private repository: DocumentRepository) {
        super('DocumentTemplate', 'sign', customizeHttpUrlGenerator, httpClient);
    }

    protected onResponse(response: DocumentModel, payload: DocumentTemplateSignPayload) {
        this.repository.updated(response);
    }

    protected buildResponse(response: any): DocumentModel {
        return this.converter.convert(response);
    }
}
export class DocumentTemplateSignPayload extends DocumentTemplateGenerateDocumentPayload {
    signature: DocumentSignPayload;
}